import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeSession } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeSession(match[1]);
        navigate("/", { replace: true, state: { user } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), 1500);
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div
        data-testid="auth-callback"
        className="text-slate-600 text-sm font-mono tracking-[0.2em] uppercase"
      >
        {error || "Signing you in…"}
      </div>
    </div>
  );
}
